import { DeliveryModel } from "api";

export const deliveriesColumns: ColumnDefinition<DeliveryModel>[] = [
  {
    property: "releaseNumber",
    sortKey: "ReleaseNumber",
    columnLabel: "Release #",
    width: "10ch",
    maxWidth: "10ch",
  },
  {
    property: "contractNumber",
    sortKey: "ContractNumber",
    columnLabel: "Contract #",
    width: "10ch",
    maxWidth: "10ch",
  },
  {
    property: "poNumber",
    sortKey: "NumAtCard",
    columnLabel: "PO #",
    width: "10ch",
    maxWidth: "13ch",
  },
  {
    property: "productName",
    sortKey: "SearchItemShortName",
    columnLabel: "Product",
    width: "15ch",
    maxWidth: "15ch",
  },
  {
    property: "quantityFormatted",
    sortKey: "SearchQuantity",
    columnLabel: "Qty",
    width: "11ch",
    maxWidth: "12ch",
    alignRight: true,
    alwaysFullWidth: true,
  },
  {
    property: "createDate",
    sortKey: "CreateDateTime",
    columnLabel: "Create Date",
    width: "11ch",
    maxWidth: "11ch",
  },
  {
    property: "docDueDate",
    sortKey: "DocDueDate",
    columnLabel: "Ship Date",
    width: "11ch",
    maxWidth: "11ch",
  },
  {
    property: "shipTo",
    sortKey: "ShipToCode",
    columnLabel: "Ship To",
    width: "15ch",
    maxWidth: "15ch",
  },
  {
    property: "mode",
    sortKey: "ModeOfTransportationCode",
    columnLabel: "Mode",
    width: "5ch",
    maxWidth: "5ch",
  },
  {
    property: "equipmentId",
    sortKey: "EquipmentId",
    columnLabel: "Equipment ID",
    width: "15ch",
    maxWidth: "15ch",
  },
  {
    property: "salesTerms",
    sortKey: "SalesTermsCode",
    columnLabel: "Sales Terms",
    width: "5ch",
    maxWidth: "5ch",
  },
  {
    property: "expandRow",
    width: "5ch",
    maxWidth: "5ch",
    hideTooltip: true,
  },
];
